import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["itemSelect", "itemInfo", "unitDisplay", "unitInput"]

  connect() {
    if (this.hasItemSelectTarget && this.itemSelectTarget.value) {
      this.itemChanged()
    }
  }

  itemChanged() {
    const itemId = parseInt(this.itemSelectTarget.value, 10)
    if (!itemId) {
      this.clearItemInfo()
      return
    }

    // item-search 컨트롤러의 items 데이터에서 선택된 품목 찾기
    const itemSearchEl = this.element.querySelector('[data-controller="item-search"]')
    if (!itemSearchEl) return

    const items = JSON.parse(itemSearchEl.dataset.itemSearchItemsValue || '[]')
    const item = items.find(i => i.id === itemId)
    if (!item) return

    const stockUnit = item.stock_unit || ''
    const useUnit = item.use_unit || stockUnit
    const currentStock = parseFloat(item.current_stock) || 0

    if (this.hasItemInfoTarget) {
      this.itemInfoTarget.textContent = `현재 재고: ${this.formatNumber(currentStock)} ${useUnit}`
    }

    if (this.hasUnitDisplayTarget) {
      this.unitDisplayTarget.textContent = stockUnit || '-'
    }
    if (this.hasUnitInputTarget) {
      this.unitInputTarget.value = stockUnit
    }
  }

  clearItemInfo() {
    if (this.hasItemInfoTarget) this.itemInfoTarget.textContent = ''
    if (this.hasUnitDisplayTarget) this.unitDisplayTarget.textContent = '-'
    if (this.hasUnitInputTarget) this.unitInputTarget.value = ''
  }

  formatNumber(num) {
    if (num === null || num === undefined) return '0'
    return Number.isInteger(num) ? num.toString() : parseFloat(num.toFixed(2)).toString()
  }
}
